export default {
	cashBalance: {
		GHS: {
			at_hand: 0,
			available: 0,
			blocked_amount: 0,
			pending_in: 0,
		},
		USD: {
			at_hand: 0,
			available: 0,
			blocked_amount: 0,
			pending_in: 0,
		},
	},
}
